/** Regex for validating resource IDs — alphanumeric, hyphens, underscores, max 64 chars.
 *  Used for festival IDs, trip IDs, and any other user-facing resource identifiers. */
export const SAFE_ID = /^[a-zA-Z0-9_-]{1,64}$/;

/** Alias for festival-specific code. Identical to SAFE_ID. */
export const FESTIVAL_ID_RE = SAFE_ID;
